<script setup lang="ts">
import HelpGeoCoverageBase from '@/views/HelpGeoCoverageBase.vue'

const stats = [
  { value: '102', label: 'Countries' },
  { value: '27', label: 'European Union' },
  { value: '75', label: 'Outside EU' },
  { value: '10', label: 'Platforms' },
]
</script>

<template>
  <HelpGeoCoverageBase
    title="Unique ads capture"
    subtitle="Countries where Ginjer captures unique advertising creatives, by paid-media platform."
    :stats="stats"
    csv-url="/help/data/unique-coverage.csv"
    other-page-url="/help/reach-coverage"
    other-page-label="View reach & impression coverage →"
    back-url="/help/platform-coverage"
    back-label="Back to Platform Coverage"
    last-updated="June 2026"
  />
</template>
